export default __webpack_public_path__ + "static/media/84a7d2491e19d6db.1481cdeeddec2237946ac505675d7093.svg";